import { useCallback } from "react";
import { useNavigate } from "react-router";

/**
 * Custom hook for client-side redirection with merged search params.
 * @returns {[(path: string) => void, boolean]} - A tuple containing the redirect function and a loading state.
 */
const useClientRedirect = () => {
  const navigate = useNavigate();

  const clientRedirect = useCallback(
    (path: string): void => {
      if (typeof window === "undefined") {
        return;
      }

      // Parse the new path and extract its search params
      const [newPathWithoutParams, newSearchString] = path?.split("?") || [];
      const newSearchParams = new URLSearchParams(newSearchString);

      // Get current search params
      const currentSearchParams = new URLSearchParams(window.location.search);

      // Merge current params with new params (new params take precedence)
      newSearchParams.forEach((value, key) => {
        currentSearchParams.set(key, value);
      });

      // Construct the final URL
      const finalSearchString = currentSearchParams.toString();
      const finalPath = finalSearchString
        ? `${newPathWithoutParams}?${finalSearchString}`
        : newPathWithoutParams;

      setTimeout(() => {
        navigate(finalPath, {
          replace: true,
        });
      }, 100);
    },
    [navigate]
  );

  return clientRedirect;
};

export default useClientRedirect;
